// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EE-z","twoColumnImage":"FE-z"};